import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import FilmsReviewedMetrics from './FilmsReviewedMetrics.vue';
import OnlineNodeMetrics from './OnlineNodeMetrics.vue';
import NodeRewardMetric from './NodeRewardMetric.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyTheaterMetrics',
  props: {
    totalNodes: null,
    totalOnline: null,
    dailyRewardCount: null,
    totalRewardCount: null
  },
  setup(__props: any) {

const props = __props as {
  totalNodes: number;
  totalOnline: number;
  dailyRewardCount?: number;
  totalRewardCount?: number;
};



const { i18n } = useContext();

const containerClass =
  'px-6 py-3 py-md-6 flex-md-grow-1 g-background-secondary rounded-lg';

return { __sfc: true,props, i18n, containerClass, FilmsReviewedMetrics, OnlineNodeMetrics, NodeRewardMetric }
}

})